// frontend/admin-portal/src/components/settings/sections/InventorySettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import TextInput from "../items/TextInput";
import NumberInput from "../items/NumberInput";
import ToggleSwitch from "../items/ToggleSwitch";

export default function InventorySettings({ values = {}, onChange }) {
  const safeOnChange = typeof onChange === "function" ? onChange : () => {};

  const units = Array.isArray(values["units.enabled"])
    ? values["units.enabled"]
    : ["pcs"];

  return (
    <div className="fh-settings-list">
      <SettingItem label="Track Inventory">
        <ToggleSwitch
          checked={values["inventory.trackStock"]}
          onChange={(v) => safeOnChange("inventory.trackStock", v)}
        />
      </SettingItem>

      <SettingItem label="Low Stock Threshold">
        <NumberInput
          value={values["inventory.lowStockThreshold"]}
          onChange={(v) => safeOnChange("inventory.lowStockThreshold", v)}
          min={0}
        />
      </SettingItem>

      <SettingItem label="Allow Sales Below Zero">
        <ToggleSwitch
          checked={values["inventory.allowBackorder"]}
          onChange={(v) => safeOnChange("inventory.allowBackorder", v)}
        />
      </SettingItem>

      <SettingItem
        label="Enabled Units"
        description="Comma-separated (pcs, m, roll, ...)"
      >
        <TextInput
          value={units.join(", ")}
          onChange={(v) =>
            safeOnChange(
              "units.enabled",
              v
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean),
            )
          }
        />
      </SettingItem>

      <SettingItem label="Default Unit">
        <TextInput
          value={values["units.default"] ?? values["inventory.defaultUnit"]}
          onChange={(v) => safeOnChange("inventory.defaultUnit", v)}
        />
      </SettingItem>

      <SettingItem label="SKU Prefix">
        <TextInput
          value={values["inventory.skuPrefix"]}
          onChange={(v) => safeOnChange("inventory.skuPrefix", v)}
        />
      </SettingItem>

      <SettingItem label="Barcode Symbology">
        <TextInput
          value={values["barcode.symbology"]}
          onChange={(v) => safeOnChange("barcode.symbology", v)}
        />
      </SettingItem>

      <SettingItem label="Barcode Prefix">
        <TextInput
          value={values["barcode.prefix"]}
          onChange={(v) => safeOnChange("barcode.prefix", v)}
        />
      </SettingItem>

      <SettingItem label="Label Size (mm)">
        <TextInput
          value={values["barcode.labelSize"]}
          onChange={(v) => safeOnChange("barcode.labelSize", v)}
        />
      </SettingItem>
    </div>
  );
}
